import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const BarcodeIdentifierType = new Enum(['BARCODE_IDENTIFIER_NONE', 'BARCODE_IDENTIFIER_SKU', 'BARCODE_IDENTIFIER_GTIN']);
export default ProtoBaseModel.extend({
  barcodeIdentifier: attr(BarcodeIdentifierType, {
    defaultValue: BarcodeIdentifierType.BARCODE_IDENTIFIER_SKU
  }),
  includeItemName: attr(Boolean, {
    defaultValue: true
  }),
  includeItemVariationName: attr(Boolean, {
    defaultValue: true
  }),
  includeRetailPrice: attr(Boolean, {
    defaultValue: true
  }),
  includeSku: attr(Boolean, {
    defaultValue: true
  }),
  includeGtin: attr(Boolean, {
    defaultValue: false
  }),
  includeMeasurementUnitAbbr: attr(Boolean, {
    defaultValue: false
  })
});